import { http } from "./http.js";

async function getData(resource, needServerInit, id) {
  const response = await http.get(
    `/${resource}/${needServerInit && id === "0" ? "new" : id}`,
  );
  return response;
}

async function updateData(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function createData(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function autoSetChildren(resource, id) {
  const response = await http.get(`${resource}/${id}`);
  return response;
}

async function changeRemovedState(resource, id, value) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !value,
    },
  );
  return response;
}

async function deleteData(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

export {
  getData,
  updateData,
  createData,
  autoSetChildren,
  changeRemovedState,
  deleteData,
};
